<template>
    <v-container 
        style="display: flex;"
        justify-center
    >
        <div class="spinner">
            <div class="pulse pulse1">
            </div>
            <div class="pulse pulse2">
            </div>
            <div class="pulse pulse3">
            </div>
        </div>  
    </v-container>
</template>

<script>
export default {
    name: "PageLoader"
}
</script>

<style scoped>
.spinner {
    margin-top: 10%;
}
.pulse {
    animation-fill-mode: both;
    animation-timing-function: cubic-bezier(0.2, 0.68, 0.18, 1.08);
    animation-iteration-count: infinite;
    animation-duration: 1s;
    animation-name: pulseStretchDelay;
    display: inline-block;
    margin: 5px;
    height: 15px;
    width: 15px;
    background-color: #7c7c7c;
}
.pulse1 {
    animation-delay: 0.12s;
}
.pulse2 {
    animation-delay: 0.24s;
}
.pulse3 {
    animation-delay: 0.36s;
}

@keyframes pulseStretchDelay {
    0%, 80% {
        -webkit-transform: scale(1);
        transform: scale(1);
        -webkit-opacity: 1;
        opacity: 1;
    }
    45% {
        -webkit-transform: scale(0.1);
        transform: scale(0.1);
        -webkit-opacity: 0.7;
        opacity: 0.7;
    }
}
</style>